import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Info = createIcon({
  displayName: "Info",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0001 4.06C7.61492 4.06 4.06006 7.61486 4.06006 12C4.06006 16.3851 7.61492 19.94 12.0001 19.94C16.3852 19.94 19.9401 16.3851 19.9401 12C19.9401 7.61486 16.3852 4.06 12.0001 4.06ZM3.06006 12C3.06006 7.06257 7.06263 3.06 12.0001 3.06C16.9375 3.06 20.9401 7.06257 20.9401 12C20.9401 16.9374 16.9375 20.94 12.0001 20.94C7.06263 20.94 3.06006 16.9374 3.06006 12ZM11.97 10.3C12.1681 10.3026 12.3573 10.3824 12.4974 10.5225C12.6375 10.6626 12.7174 10.8519 12.72 11.05V15.05C12.72 15.2489 12.641 15.4397 12.5003 15.5803C12.3596 15.721 12.1689 15.8 11.97 15.8C11.7711 15.8 11.5803 15.721 11.4396 15.5803C11.299 15.4397 11.22 15.2489 11.22 15.05V11.05C11.22 10.8511 11.299 10.6603 11.4396 10.5197C11.5803 10.379 11.7711 10.3 11.97 10.3ZM11.27 8.58003C11.27 8.17134 11.6013 7.84003 12.01 7.84003C12.4187 7.84003 12.75 8.17134 12.75 8.58003C12.75 8.98872 12.4187 9.32003 12.01 9.32003C11.6013 9.32003 11.27 8.98872 11.27 8.58003Z"
    />
  )
});
